import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import AccountingReportLogEntry, {
  newAccountingReportEntry,
} from "../../models/accounting-reports";
import AccountingReportLogForm from "./AccountingReportLogForm";
import { formatUTCDateTime } from "../../utils/dates";

interface AccountingReportLogUpdateModalProps {
  show: boolean;
  accountingreportlog?: AccountingReportLogEntry;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const AccountingReportLogUpdateModal: React.FC<
  AccountingReportLogUpdateModalProps
> = ({ show, accountingreportlog, onCancel, onSuccess }) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialAccountingReportLog, setInitialAccountingReportLog] =
    useState<AccountingReportLogEntry>(
      accountingreportlog ? accountingreportlog : newAccountingReportEntry()
    );

  const modalTitle = accountingreportlog
    ? `Editar Datos de Reporte: ${accountingreportlog.obs} - ${
        accountingreportlog.createdAt
          ? formatUTCDateTime(new Date(accountingreportlog.createdAt))
          : ""
      }`
    : `Crear Reporte Contable Nuevo`;

  const onClose = () => {
    setInitialErrors({});
    setInitialAccountingReportLog(newAccountingReportEntry());
    onCancel();
  };
  useEffect(() => {
    setInitialAccountingReportLog(
      accountingreportlog ? accountingreportlog : newAccountingReportEntry()
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountingreportlog]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <AccountingReportLogForm
            initialAccountingReportLog={initialAccountingReportLog}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default AccountingReportLogUpdateModal;
